<!--
  LoadingMask - 全局加载遮罩组件
  使用: <LoadingMask :visible="loading" :text="loadingText" />
-->
<template>
  <div v-if="visible" class="mask">
    <div class="content">
      <a-spin size="large" />
      <div class="text">{{ text || '正在处理您的请求' }}</div>
      <div class="subtitle">请稍后，这个可能需要几秒钟</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingMask',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="less" scoped>
.mask {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  min-width: 100vw !important;
  min-height: 100vh !important;
  margin: 0 !important;
  padding: 0 !important;
  background: rgba(0, 0, 0, 0.6) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 9999 !important;
  pointer-events: auto !important;
  overflow: hidden !important;
}

.content {
  background: #fff;
  border-radius: 20px;
  padding: 32px 40px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
}

.text {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin: 20px 0 10px 0;
}

.subtitle {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

@media (max-width: 768px) {
  .content {
    margin: 20px;
    padding: 24px 20px;
  }

  .text {
    font-size: 16px;
  }

  .subtitle {
    font-size: 13px;
  }
}
</style>
